/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SignatureAuthority } from './SignatureAuthority';
import {
    SignatureAuthorityFromJSON,
    SignatureAuthorityFromJSONTyped,
    SignatureAuthorityToJSON,
    SignatureAuthorityToJSONTyped,
} from './SignatureAuthority';

/**
 * 
 * @export
 * @interface SafeDepositBoxSignatureAuthorityOption
 */
export interface SafeDepositBoxSignatureAuthorityOption {
    /**
     * 
     * @type {SignatureAuthority}
     * @memberof SafeDepositBoxSignatureAuthorityOption
     */
    value: SignatureAuthority;
    /**
     * 
     * @type {string}
     * @memberof SafeDepositBoxSignatureAuthorityOption
     */
    label: string;
}



/**
 * Check if a given object implements the SafeDepositBoxSignatureAuthorityOption interface.
 */
export function instanceOfSafeDepositBoxSignatureAuthorityOption(value: object): value is SafeDepositBoxSignatureAuthorityOption {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function SafeDepositBoxSignatureAuthorityOptionFromJSON(json: any): SafeDepositBoxSignatureAuthorityOption {
    return SafeDepositBoxSignatureAuthorityOptionFromJSONTyped(json, false);
}

export function SafeDepositBoxSignatureAuthorityOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SafeDepositBoxSignatureAuthorityOption {
    if (json == null) {
        return json;
    }
    return {
        
        'value': SignatureAuthorityFromJSON(json['value']),
        'label': json['label'],
    };
}

export function SafeDepositBoxSignatureAuthorityOptionToJSON(json: any): SafeDepositBoxSignatureAuthorityOption {
    return SafeDepositBoxSignatureAuthorityOptionToJSONTyped(json, false);
}

export function SafeDepositBoxSignatureAuthorityOptionToJSONTyped(value?: SafeDepositBoxSignatureAuthorityOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': SignatureAuthorityToJSON(value['value']),
        'label': value['label'],
    };
}

